import { Link, useParams } from 'react-router-dom';
import { useAuth } from '../auth/useAuth.js';

export function Footer() {
  const { tenantSlug } = useParams();
  const { isAuthenticated } = useAuth();
  const tenantPath = (path: string) => `/app/${tenantSlug ?? 'workspace'}/${path}`;

  return (
    <footer className="main-footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Platform</h3>
          <ul>
            <li><Link to={isAuthenticated ? tenantPath('dashboard') : '/'}>Dashboard</Link></li>
            <li><Link to={isAuthenticated ? tenantPath('docs') : '/docs'}>Documentation</Link></li>
            <li><Link to="/api">API Reference</Link></li>
            <li><Link to={isAuthenticated ? tenantPath('status') : '/status'}>System Status</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Resources</h3>
          <ul>
            <li><Link to={isAuthenticated ? tenantPath('help') : '/support'}>Help Center</Link></li>
            <li><Link to="/community">Community</Link></li>
            <li><Link to="/blog">Blog</Link></li>
            <li><Link to="/support">Support</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Legal</h3>
          <ul>
            <li><Link to="/terms">Terms of Service</Link></li>
            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            <li><Link to="/cookie-policy">Cookie Policy</Link></li>
            <li><Link to={isAuthenticated ? tenantPath('compliance') : '/gdpr'}>Compliance</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Connect</h3>
          <ul>
            <li><a href="https://twitter.com" target="_blank" rel="noopener noreferrer">Twitter</a></li>
            <li><a href="https://linkedin.com" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
            <li><a href="https://facebook.com" target="_blank" rel="noopener noreferrer">Facebook</a></li>
            <li><a href="https://instagram.com" target="_blank" rel="noopener noreferrer">Instagram</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom"><p>&copy; {new Date().getFullYear()} BumBum Platform. All rights reserved.</p></div>
    </footer>
  );
}